import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Loader from '../components/Loader';
import Weather from '../components/Weather';
import store from '../components/Store';

const API_URL = 'https://api.allorigins.win/get?url=' + encodeURIComponent('https://www.metaweather.com/api/location/search/?query=');
//const API_URL = 'https://www.metaweather.com/api/location/search/?query=';
//const API_URL = 'http://localhost:8080/weather.php?command=search&keyword=';
//const API_URL = '/weather.php?command=search&keyword=';

class SearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            text: decodeURIComponent(this.props.match.params.term),
            redirect: false,
            data: null
        };
    }

    componentDidMount() {
        let searchData = store.get('search_'+this.props.match.params.term);
        if ( searchData ) {
            this.setState({
                loading: false,
                data: searchData
            });
        } else {
            fetch(API_URL+this.props.match.params.term)
            .then(response => response.json())
            .then(jsonResponse => {
                if (jsonResponse.contents) jsonResponse = JSON.parse(jsonResponse.contents);
                store.set('search_'+this.props.match.params.term, jsonResponse);
                this.setState({
                    loading: false,
                    data: jsonResponse
                });
            });
        }
    }

    handleOnClick = () => {
        this.setState({redirect: true});
    }

    handleInput = (evt) => {
        this.setState({text: evt.target.value});
    }

    render() {
        if ( this.state.redirect ) {
            // redirect and update url
            return (<Redirect push to={"/search/"+encodeURIComponent(this.state.text.toLowerCase())} />);
        }
        return (
            <div className="page page-search">
                <h2 className="page-header">Search Results</h2>
                <div className="search-box">
                    <input type="text" placeholder="search.." value={this.state.text} onChange={this.handleInput} />
                    <button type="button" onClick={this.handleOnClick}>Search!</button>
                </div>
                {this.state.loading ? (<Loader text="Loading.." />) : (this.state.data && this.state.data.length ? this.state.data.map(place => <Weather key={'weather_for_'+place.woeid} woeid={place.woeid} city={place.title} />) : (<p><b>No results found!</b></p>))}
            </div>
        );
    }
}

export default SearchPage;
